import { useCallback, useEffect } from 'react'
import { useValidatorSeeker } from '@app'
import { formatDate } from '@ui-seeker/utils'
import { useComputed } from '@preact/signals-react'
import { object } from 'yup'
import { capitalize } from '@mui/material'

import { formData, formErrors } from '@signals'


export default function useAppFormHandler(key, validation = object({}), isDate = false) {
	const fieldValue = useComputed(() => formData.value[key])
	const { isValid, errors } = useValidatorSeeker({ [key]: fieldValue.value }, validation)

	const onChange = useCallback(value => {
		formData.value = { ...formData.value, [key]: isDate ? formatDate(value) : value }
	}, [])

	useEffect(() => {
		formErrors.value = { ...formErrors.value, [key]: isValid }
	}, [isValid])

	return {
		[key]: fieldValue.value,
		[`on${capitalize(key)}Change`]: onChange,
		error: errors[key],
	}
}